import {
    buildEmptyMeasurements,
    isRoofMeasurementKey,
} from "../../../constants/roofMeasurements";
import type { IRoofMeasurementsForm } from "../../../interfaces";
import {
    parseMeasurementAttributeValue,
    serializeMeasurementAttributeValue,
} from "../../../utils/measurementAttribute";

import type { BackendAttribute } from "../hooks/useInit";

export function hydrateMeasurementsFromAttributes(
    attributes: BackendAttribute[],
): { flatData: Record<string, any>; measurements: IRoofMeasurementsForm } {
    const measurements = buildEmptyMeasurements();
    const flatData: Record<string, any> = {};

    attributes.forEach((attr) => {
        const name = attr.AttributeName;

        if (isRoofMeasurementKey(name)) {
            measurements[name] = parseMeasurementAttributeValue(
                attr.AttributeValue,
            );
            return;
        }

        let value: any = attr.AttributeValue;

        if (
            typeof value === "string" &&
            (value.startsWith("[") || value.startsWith("{"))
        ) {
            try {
                value = JSON.parse(value);
            } catch {
                // keep string
            }
        }

        flatData[name] = value;
    });

    flatData.Measurements = measurements;
    return { flatData, measurements };
}

export function expandMeasurementsForSync(
    currentData: Record<string, any>,
): Record<string, any> {
    const { Measurements, ...rest } = currentData;
    const expanded: Record<string, any> = { ...rest };

    if (!Measurements || typeof Measurements !== "object") {
        return expanded;
    }

    Object.entries(Measurements).forEach(([key, entry]) => {
        if (!isRoofMeasurementKey(key) || !entry || typeof entry !== "object")
            return;

        expanded[key] = {
            __measurement: true,
            Value: serializeMeasurementAttributeValue(
                entry as { Calculated?: number; Actual?: number },
            ),
        };
    });

    return expanded;
}
